import { createSlice } from "@reduxjs/toolkit";

const initialReportsState = {
  reportsList: [],
  listLoading: false,
  error: null,
  hideLoading: false,
  contentHided: null,
  reportsReviewed: true,
  commentHided: null,
  articleHided: null
};

export const callTypes = {
  list: "list",
  hide: "hide",
};

export const reportsSlice = createSlice({
  name: "Posts",
  initialState: initialReportsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.payload.error}`;
      switch (action.payload.callType) {
        case callTypes.list:
          state.listLoading = false;
          break;
        case callTypes.hide:
          state.hideLoading = false;
          break;
        default:
          break;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      switch (action.payload.callType) {
        case callTypes.list:
          state.listLoading = true;
          break;
        case callTypes.hide:
          state.hideLoading = true;
          break;
        default:
          break;
      }
    },
    reportsFetched: (state, action) => {
      state.reportsList = [...action.payload.reportsList];
      state.listLoading = false;
      state.hideLoading = false;
      state.error = null;
    },
    reportsReviewed: (state, action) => {
      state.listLoading = false;
      state.hideLoading = false;
      state.reportsReviewed = true;
    },
    contentHided: (state, action) => {
      state.contentHided = action.payload.contentHided;
      state.hideLoading = false;
      state.error = null;
    },
    commentHided: (state, action) => {
      state.commentHided = action.payload.commentHided;
      state.hideLoading = false;
      state.error = null;
    },
    articleHided: (state, action) => {
      state.articleHided = action.payload.articleHided;
      state.hideLoading = false;
      state.error = null;
    },
  },
});
